var o="com.guild.demos";export{o as SESSION_URLS_STORAGE_KEY};
//# sourceMappingURL=SESSION_URLS_STORAGE_KEY.js.map
